module.exports = __webpack_public_path__ + "img/lightmode_texture.778f003b.png";